var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25.0002L0.501924 24.9563L0.454077 25.5002H1V25.0002ZM13 14.0089L13.0225 14.5085L13.0284 14.5081L13 14.0089ZM25 25.0002V25.5002H25.5829L25.4942 24.9241L25 25.0002ZM18.9615 7.49996C18.9615 10.8521 16.4622 13.4999 13.4615 13.4999V14.4999C17.0883 14.4999 19.9615 11.3275 19.9615 7.49996H18.9615ZM13.4615 13.4999C10.4609 13.4999 7.96154 10.8521 7.96154 7.49996H6.96154C6.96154 11.3275 9.83476 14.4999 13.4615 14.4999V13.4999ZM7.96154 7.49996C7.96154 4.14784 10.4609 1.5 13.4615 1.5V0.5C9.83476 0.5 6.96154 3.67242 6.96154 7.49996H7.96154ZM13.4615 1.5C16.4622 1.5 18.9615 4.14784 18.9615 7.49996H19.9615C19.9615 3.67242 17.0883 0.5 13.4615 0.5V1.5ZM1.49808 25.044C1.64439 23.381 2.39757 20.8323 4.17893 18.66C5.94676 16.5042 8.73963 14.7016 13.0225 14.5084L12.9775 13.5095C8.39883 13.716 5.34555 15.6603 3.40568 18.0259C1.47936 20.375 0.663305 23.1221 0.501924 24.9563L1.49808 25.044ZM13.0284 14.5081C14.3784 14.4312 16.9252 14.8996 19.2992 16.4856C21.6525 18.0578 23.8363 20.728 24.5058 25.0762L25.4942 24.9241C24.7791 20.2795 22.4245 17.3709 19.8547 15.6541C17.3055 13.951 14.5447 13.4201 12.9716 13.5098L13.0284 14.5081ZM25 24.5002H1V25.5002H25V24.5002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountIcon);
export default __webpack_public_path__ + "static/media/MyAccountIcon.5ccf76afdab7b0aa254d513d0e8da3da.svg";
export { ForwardRef as ReactComponent };